<div class="tuning-container" *ngIf="cMatch && vcoat">
  <app-formula-tuner [colourMatch]="cMatch" [coat]="vcoat.coat" [job]="job()"></app-formula-tuner>
</div>